<div *ngIf="visible" class="force-logout-overlay">
  <div class="force-logout-modal">

    <div class="force-logout-icon">
      <i class="bi bi-shield-exclamation"></i>
    </div>

    <h5 class="force-logout-title">Access Updated</h5>

    <p class="force-logout-message">{{ message }}</p>

    <button class="btn force-logout-btn w-100" (click)="onConfirm()">
      OK, Log me out
    </button>

  </div>
</div>